import { CreateCandidateResumeInput, CreateTimesheetInput, ContractorActivity as ContractorActivityGQL } from './API';

export type CandidateResume = CreateCandidateResumeInput;
export type Timesheet = CreateTimesheetInput;

export interface IConnectListQuery<T, keyName extends string> {
  data: { [key in keyName]: { items: T[]; nextToken: string | null } };
  loading: boolean;
}

export interface IConnectGetQuery<T, keyName extends string> {
  data: { [key in keyName]: T };
  loading: boolean;
}

export enum ContractStatus {
  DRAFT = 'draft',
  OPEN = 'open',
  CLOSE = 'close',
  CANCEL = 'cancel',
}
export type ContractorActivity = Omit<ContractorActivityGQL, "__typename" | "id" | "createdAt" | "updatedAt"> & { id?: string; };

export type IdField = [number, string];

export type Employee = {
  user_id: IdField;
  user_partner_id: IdField;
  active: string;
  address_home_id: IdField;
  is_address_home_a_company: string;
  private_email: string;
  country_id: IdField;
  gender: string;
  marital: string;
  spouse_complete_name: string;
  spouse_birthdate: string;
  children: string;
  place_of_birth: string;
  country_of_birth: IdField;
  birthday: string;
  ssnid: string;
  sinid: string;
  identification_id: string;
  passport_id: string;
  bank_account_id: IdField;
  permit_no: string;
  visa_no: string;
  visa_expire: string;
  additional_note: string;
  certificate: string;
  study_field: string;
  study_school: string;
  emergency_contact: string;
  emergency_phone: string;
  km_home_work: string;
  image_1920: string;
  phone: string;
  child_ids: string;
  category_ids: string;
  notes: string;
  color: string;
  barcode: string;
  pin: string;
  departure_reason: string;
  departure_description: string;
  message_main_attachment_id: IdField;
  medic_exam: string;
  vehicle: string;
  contract_ids: string;
  contract_id: IdField;
  calendar_mismatch: string;
  contracts_count: string;
  contract_warning: string;
  subordinate_ids: string;
  slip_ids: string;
  payslip_count: string;
  registration_number: string;
  newly_hired_employee: string;
  expense_manager_id: IdField;
  employee_code: string;
  cost_card: IdField;
  customer: IdField;
  wage: number;
  employee_type: string;
  name: string;
  join_date: string;
  line_manager: IdField;
  senior_manager: IdField;
  contract_signing_date: string;
  medical_insur: string;
  medical_insur_no: string;
  MI_carrier: string;
  MI_poloicy_type: string;
  medical_history: string;
  blood_type: string;
  next_to_kin: string;
  local_address: string;
  personal_mob: string;
  personal_email: string;
  language_spoken: IdField;
  name_ar: string;
  job_location: string;
  designation: string;
  company_identification: string;
  home_company_address: string;
  passport_expiry: string;
  name_in_passport: string;
  visa_type: string;
  driver_licence_no: string;
  driver_licence_class: string;
  vehicle_plate_no: string;
  iqama_no: string;
  iqama_name: string;
  iqama_expiry: string;
  iqama_profession: string;
  iqama_profession_ar: string;
  dob_hijri: string;
  med_ins_policy_no: string;
  primary_hosp_home: string;
  primary_hosp_local: string;
  primary_care_physician_home: string;
  primary_care_physician_local: string;
  contact_details_home: string;
  contact_details_local: string;
  policy_exipry: string;
  carrier: string;
  class_c: string;
  computer_tag: string;
  compute_id: IdField;
  phone_tag: string;
  mobile_id: string;
  vehicle_id: IdField;
  imie_tag: string;
  docs_ids: string;
  emp_event_ids: string;
  emp_event_accomodation_ids: string;
  emp_event_transportation_ids: string;
  emp_event_accident_ids: string;
  emp_event_vacation_ids: string;
  emp_event_training_ids: string;
  emp_event_hse_incident_ids: string;
  emp_event_career_ids: string;
  visa_category: string;
  allow_multiple_loans: string;
  loan_defaulter: string;
  education: IdField;
  country: IdField;
  cv: string;
  university: string;
  contact_no: string;
  client_email: string;
  sick_leaves: string;
  branch_name: string;
  beneficiary_name: string;
  account_no: string;
  iban: string;
  swift_routing_no: string;
  uae_visa_held: string;
  level_of_education: string;
  prob_period: string;
  notice_period: string;
  work_days: string;
  visa_entity: string;
  child_depend: string;
  relation: string;
  image_1024: string;
  image_512: string;
  image_256: string;
  image_128: string;
  activity_ids: string;
  activity_state: string;
  activity_user_id: IdField;
  activity_type_id: IdField;
  activity_date_deadline: string;
  activity_summary: string;
  activity_exception_decoration: string;
  activity_exception_icon: string;
  message_is_follower: string;
  message_follower_ids: string;
  message_partner_ids: string;
  message_channel_ids: string;
  message_ids: string;
  message_unread: string;
  message_unread_counter: string;
  message_needaction: string;
  message_needaction_counter: string;
  message_has_error: string;
  message_has_error_counter: string;
  message_attachment_count: string;
  website_message_ids: string;
  message_has_sms_error: string;
  department_id: IdField;
  job_id: IdField;
  job_title: string;
  company_id: IdField;
  address_id: IdField;
  work_phone: string;
  mobile_phone: string;
  work_email: string;
  work_location: string;
  resource_id: IdField;
  resource_calendar_id: IdField;
  parent_id: IdField;
  coach_id: IdField;
  tz: string;
  hr_presence_state: string;
  last_activity: string;
  last_activity_time: string;
  goal_ids: string;
  badge_ids: string;
  has_badges: string;
  direct_badge_ids: string;
  leave_manager_id: IdField;
  remaining_leaves: number;
  current_leave_state: string;
  current_leave_id: IdField;
  leave_date_from: string;
  leave_date_to: string;
  leaves_count: number;
  allocation_count: number;
  allocation_used_count: number;
  show_leaves: string;
  is_absent: string;
  allocation_display: string;
  allocation_used_display: string;
  child_all_count: string;
  id: string;
  display_name: string;
  create_uid: IdField;
  create_date: string;
  write_uid: IdField;
  write_date: string;
  __last_update: string;
};

export type Contract = {
  name: string;
  active: string;
  employee_id: IdField;
  department_id: IdField;
  job_id: IdField;
  date_start: string;
  date_end: string;
  trial_date_end: string;
  wage: string;
  advantages: string;
  notes: string;
  state: string;
  company_id: IdField;
  kanban_state: string;
  currency_id: IdField;
  permit_no: string;
  visa_no: string;
  visa_expire: string;
  hr_responsible_id: IdField;
  calendar_mismatch: string;
  structure_type_id: IdField;
  schedule_pay: string;
  resource_calendar_id: IdField;
  hours_per_week: number;
  full_time_required_hours: number;
  is_fulltime: string;
  wage_type: string;
  hourly_wage: string;
  date_generated_from: string;
  date_generated_to: string;
  company_country_id: IdField;
  analytic_account_id: IdField;
  contract_length: string;
  cost_card: IdField;
  activity_ids: string;
  activity_state: string;
  activity_user_id: IdField;
  activity_type_id: IdField;
  activity_date_deadline: string;
  activity_summary: string;
  activity_exception_decoration: string;
  activity_exception_icon: string;
  message_is_follower: string;
  message_follower_ids: string;
  message_partner_ids: string;
  message_channel_ids: string;
  message_ids: string;
  message_unread: string;
  message_unread_counter: string;
  message_needaction: string;
  message_needaction_counter: string;
  message_has_error: string;
  message_has_error_counter: string;
  message_attachment_count: string;
  message_main_attachment_id: IdField;
  website_message_ids: string;
  message_has_sms_error: string;
  id: string;
  display_name: string;
  create_uid: IdField;
  create_date: string;
  write_uid: IdField;
  write_date: string;
  __last_update: string;
};
